export default "__VITE_ASSET__DHfD$t0a__"